import { useEffect } from 'react';
import type { PanelComponentProps } from '../../components/AdminSidePanel';
import { useAdminSections } from './hooks/useAdminSections';
import { SectionList } from './components/SectionList';

export function KommunaleSectionsView({ onPanelWidthChange }: PanelComponentProps) {
    const adminSections = useAdminSections({ type: 'kommune', planId: '' });

    useEffect(() => {
        onPanelWidthChange?.(Math.floor(window.innerWidth * 0.6));
    }, [onPanelWidthChange]);

    return (
        <SectionList
            seksjoner={adminSections.seksjoner}
            contextLabel="Generelle veiledningspunkt"
            contextSubtitle="Veiledningspunkter som vises til innbygger for hele kommunen."
            flatView
            onAdd={(values) => adminSections.addSeksjon(values)}
            onUpdate={(existing, values) =>
                adminSections.updateSeksjon(String(existing.objectId), values)
            }
            onDelete={adminSections.deleteSeksjon}
            onToggleOverride={adminSections.toggleOverride}
            onHide={adminSections.hideSection}
            onUnhide={adminSections.unhideSection}
            onReorder={adminSections.reorder}
        />
    );
}
